import type { ConversationAction } from '@atlassian/rovo-conversation-actions/types';

import type { ConversationActionWithAssistantMetadata } from './action-capabilities';
import { getConversationActionWithAssistantMetadata } from './getConversationActionWithAssistantMetadata';

export const getActionOnDismiss = (
	action: ConversationAction | undefined,
): ConversationActionWithAssistantMetadata['onDismiss'] =>
	getConversationActionWithAssistantMetadata(action)?.onDismiss;
